// extracted by mini-css-extract-plugin
module.exports = {"container":"AllocationChart_container__nqeWs","percentageBar":"AllocationChart_percentageBar__3hLol","right":"AllocationChart_right__1N_lq"};